export default "__VITE_ASSET__DCd5Scdj__"